import { Card, Divider, Icon, Input, Text } from "@ui-kitten/components";
import React from "react";
import { View } from "react-native";
import { Rating } from "../recipe/rating";
import { ManufacturerForm } from "./manufacturer/ManufacturerForm";

interface FlavorFormProps {
    onNameChange: (name: string) => void;
    onRatingChange: (rating: number | undefined) => void;
    onWarningChange: (warning: string) => void;
    onCommentChange: (comment: string) => void;
    onSingleFlavorPercentageChange: (comment: string) => void;
    onInMixPercentageChange: (comment: string) => void;
    name: string;
    rating?: number;
    warning?: string;
    comment?: string;
    singleFlavorPercentage?: string;
    inMixPercentage?: string;
}

export const FlavorForm = ({
    onNameChange,
    onRatingChange,
    onWarningChange,
    onCommentChange,
    onSingleFlavorPercentageChange,
    onInMixPercentageChange,
    name,
    rating,
    warning,
    comment,
    singleFlavorPercentage,
    inMixPercentage,
}: FlavorFormProps) => {
    return (
        <Card status="primary" style={{ marginTop: 16 }}>
            <ManufacturerForm />
            <Divider style={{ marginVertical: 16 }} />
            <Input
                label={() => (
                    <Text style={{ marginBottom: 5 }} category="c2">
                        Name
                    </Text>
                )}
                placeholder="Give your flavor a name"
                value={name}
                onChangeText={onNameChange}
                style={{ marginBottom: 16 }}
            />
            <Divider style={{ marginVertical: 16 }} />
            <Text style={{ marginBottom: 5 }} category="c2">
                Recommended percentage
            </Text>
            <View style={{ display: "flex", flexDirection: "row", justifyContent: "space-evenly" }}>
                <Input
                    label={() => (
                        <Text style={{ marginBottom: 5 }} category="c2">
                            In Recipes
                        </Text>
                    )}
                    placeholder="%"
                    value={inMixPercentage}
                    onChangeText={onInMixPercentageChange}
                    style={{ marginBottom: 16, flex: 1, marginRight: 5 }}
                />
                <Input
                    label={() => (
                        <Text style={{ marginBottom: 5 }} category="c2">
                            Single Flavor
                        </Text>
                    )}
                    placeholder="%"
                    value={singleFlavorPercentage}
                    onChangeText={onSingleFlavorPercentageChange}
                    style={{ marginBottom: 16, flex: 1 }}
                />
            </View>
            <Divider style={{ marginVertical: 10 }} />
            <Text style={{ marginBottom: 5 }} category="c2">
                Rating
            </Text>
            <Rating size="large" autoExpand={false} rating={rating} onChange={onRatingChange} />
            <Divider style={{ marginVertical: 10 }} />
            <Input
                multiline={true}
                textStyle={{ minHeight: 40 }}
                label={() => (
                    <View style={{ flexDirection: "row", marginBottom: 5 }}>
                        <Text style={{ marginRight: 5 }} category="c2">
                            Warning
                        </Text>
                        <Icon name="alert-triangle-outline" style={{ width: 16, height: 16 }} />
                    </View>
                )}
                placeholder="Acetoin, etc"
                value={warning}
                onChangeText={onWarningChange}
                style={{ marginBottom: 16 }}
            />
            <Input
                multiline={true}
                textStyle={{ minHeight: 120 }}
                label={() => (
                    <Text style={{ marginBottom: 5 }} category="c2">
                        Comment
                    </Text>
                )}
                placeholder="Add a comment..."
                value={comment}
                onChangeText={onCommentChange}
                style={{ marginBottom: 16 }}
            />
        </Card>
    );
};
